export const SELECT_FILTER = 'Please Select a Filter'; // Filter error
export const BOOKING_LIST_ERROR = 'Unable to fetch booking list' // Booking List Error
export const FETCHING_FAILED = 'An error occurred while fetching data' // Fetching Failed